import {Model} from "@vuex-orm/core";

export class BaseModel extends Model{
    static modelKey = null;

    static getMany(config = null) {
        return this.api().get(`${this.modelKey}`, {
            dataTransformer: ({data}) => {
                return data.data;
            },
            ...config
        });
    }

    static get(id, config = null) {
        return this.api().get(`${this.modelKey}/${id}`, {
            dataTransformer: ({data}) => {
                return data.data;
            },
            ...config
        });
    }

    static post(data, config = null) {
        data = {...data};
        delete data.id;
        delete data.$id;
        return this.api().post(this.modelKey, data, {
            dataTransformer: ({data}) => {
                return data.data;
            },
            ...config
        });
    }

    static remove(id) {
        return this.api().delete(`${this.modelKey}/${id}`, {delete: id});
    }

    static put(id, data, config = null) {
        data = {...data};
        delete data.id;
        delete data.$id;
        return this.api().put(`${this.modelKey}/${id}`, data, {
            dataTransformer: ({data}) => {
                return data.data;
            },
            ...config
        })
    }
}
